import { lazy } from 'react';

import Loadable from 'ui-component/Loadable';

// ==============================|| PUBLIC REPORT ROUTING ||============================== //
// Deliberately NOT wrapped in AuthGuard/MainLayout — this is the unauthenticated link sent
// by SendReportEmailButton. See modules/shared/publicFinalReportRegistry.tsx.

const PublicFinalReportPage = Loadable(lazy(() => import('pages/PublicFinalReportPage')));

const PublicReportRoutes = {
  path: '/public-report',
  children: [
    { path: ':studyTypeKey/:tesCode', element: <PublicFinalReportPage /> }
  ]
};

export default PublicReportRoutes;
